'use strict';

(function () {
    'use strict';

    translationsConfig.$inject = ['$translateProvider'];
    angular.module('app.admin').config(translationsConfig);

    /* @ngInject */
    function translationsConfig($translateProvider) {

        $translateProvider.translations('en-US', {
            'admin': {
                'alert': {
                    'description': 'description'
                },
                'alert-group': {
                    'description': 'description'
                },
                'parking': {
                    'description': 'description',
                    'filters': {
                        'All': 'All',
                        'Free': 'Free',
                        'Occupied': 'Occupied',
                        'Offline': 'Offline'
                    },
                    'status': {
                        'Free': 'Free',
                        'Occupied': 'Occupied',
                        'Offline': 'Offline'
                    },
                    'since': 'since',
                    'Last change': 'Last change',
                    'last change': 'last change',
                    'Name': 'Name',
                    'Status': 'Status',
                    'Since': 'Since',
                    'Last update': 'Last update'
                },

                'gateway': {
                    'Online': 'Online',
                    'Offline': 'Offline'
                },
                'device': {
                    'Online': 'Online',
                    'Offline': 'Offline'
                },
                'analytics-mode': {
                    'name': 'name_el'
                },
                'login': {
                    'Welcome,': 'Welcome,',
                    'Login': 'Login',
                    'Logout': 'Logout',
                    'Sign in': 'Sign in',
                    'Email address': 'Email address',
                    'Password': 'Password',

                    'Sorry, we could not log you in.': 'Sorry, we could not log you in.'
                },
                'iot-status': {
                    'Gateway': 'Gateway',
                    'Alerts (today)': 'Alerts (today)',
                    'Status': 'Status',
                    'Since': 'Since'
                },
                'iot-map': {
                    'see more': 'more...',
                    'Gateways': 'Gateways',
                    'Devices': 'Devices',
                    'All': 'All',
                    'Urban environment': 'Urban environment',
                    'Water resources': 'Water resources',
                    'Parking': 'Parking',
                    'Alerts (today)': 'alerts (today)',
                    'since': 'since',
                    'Online': 'Online',
                    'Offline': 'Offline'
                },
                'gateway-status': {
                    'Online': 'Online',
                    'Offline': 'Offline',
                    'since': 'since',
                    'Devices': 'Devices',
                    'Dashboard': 'Dashboard',
                    'Latest values': 'Latest values'
                },
                'device-status': {
                    'Online': 'Online',
                    'Offline': 'Offline',
                    'Dashboard': 'Dashboard',
                    'Sensors': 'Sensors',
                    'Latest values': 'Latest values',
                    'alerts': 'alerts',
                    'No Value': 'No Value',
                    'Normal': 'Normal'
                }
            }
        });
    }
})();